import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchAsyncGetAccountUser } from "redux/embrillProfileSlice";

const useAccountUser  = () => {
  const dispatch = useDispatch();
  const currUser  = useSelector((state) => state.auth.currUser );
  const [accountUser , setAccountUser ] = useState(null);

  useEffect(() => {
      (async()=>{
        if (currUser  && currUser._id) {
          const res = await dispatch(fetchAsyncGetAccountUser(currUser._id));
          if (res?.payload?.isA) {
            setAccountUser (res.payload);
          } else {
            setAccountUser ({});
          }
        } else {
          setAccountUser (null);
        }
      })()
  }, [currUser, dispatch]);

  return accountUser ;
};

export default useAccountUser ;
